const PATHS: Record<string, string> = {
  list: "M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01",
  tag: "M3 3h8l10 10-8 8L3 11zM7.5 7.5h.01",
  cash: "M3 7h18v10H3zM12 15a3 3 0 100-6 3 3 0 000 6zM6.5 12h.01M17.5 12h.01",
  pulse: "M3 12h4l3-7 4 14 3-7h4",
  till: "M3 7h18v12H3zM7 7V4h10v3M7 12h4M7 15h2",
  dash: "M4 13h6V4H4zM14 20h6v-9h-6zM14 4h6v4h-6zM4 20h6v-4H4z",
  report: "M5 20V10M12 20V4M19 20v-7",
  box: "M3 8l9-5 9 5v8l-9 5-9-5zM3 8l9 5 9-5M12 13v8",
  truck: "M3 6h11v10H3zM14 10h4l3 3v3h-7M5 18a2 2 0 104 0 2 2 0 10-4 0M15 18a2 2 0 104 0 2 2 0 10-4 0",
  team: "M6 8a3 3 0 106 0 3 3 0 10-6 0M3 20c.8-3.5 3.2-5 6-5s5.2 1.5 6 5M16 5a3 3 0 010 6M21 20c-.4-2-1.4-3.4-3-4.2",
  gear: "M9 12a3 3 0 106 0 3 3 0 10-6 0M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4",
  lock: "M5 11h14v9H5zM8 11V8a4 4 0 018 0v3",
  search: "M4 11a7 7 0 1014 0 7 7 0 10-14 0M20 20l-3.5-3.5",
  scan: "M4 6v12M7 6v12M10 6v12M14 6v12M17 6v12M20 6v12",
  menu: "M4 7h16M4 12h16M4 17h16",
  chev: "M9 6l6 6-6 6",
  more: "M4 12h.01M12 12h.01M20 12h.01",
  x: "M6 6l12 12M18 6L6 18",
  cloud: "M7 18h10a4 4 0 00.5-8A6 6 0 006 9a4.5 4.5 0 001 9zM12 11v6M9 14l3-3 3 3",
  plus: "M12 5v14M5 12h14",
  bank: "M3 10l9-6 9 6M5 10v8M10 10v8M14 10v8M19 10v8M3 20h18",
  phone: "M8 3h8a1 1 0 011 1v16a1 1 0 01-1 1H8a1 1 0 01-1-1V4a1 1 0 011-1zM11 18h2",
  person: "M12 11a4 4 0 100-8 4 4 0 000 8zM4 21c1-4.5 4-6.5 8-6.5s7 2 8 6.5",
  dots: "M5 12h.01M12 12h.01M19 12h.01",
  logout: "M10 4H5v16h5M15 8l4 4-4 4M19 12H9",
  pencil: "M4 20l1-4L16 5l3 3L8 19zM14 7l3 3",
  check: "M5 12.5l4.5 4.5L19 7.5",
  trash: "M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v5M14 11v5",
  printer: "M7 8V3h10v5M7 17H4v-7a2 2 0 012-2h12a2 2 0 012 2v7h-3M7 14h10v7H7z",
  download: "M12 4v11M7.5 11l4.5 4.5 4.5-4.5M4 20h16",
  left: "M15 6l-6 6 6 6",
  label: "M3 5h11l7 7-7 7H3zM7 9h.01",
  panel: "M4 4h16a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1zM9 4v16",
  eye: "M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12zM9 12a3 3 0 106 0 3 3 0 10-6 0",
  eyeOff: "M3 3l18 18M10.6 5.1A9.7 9.7 0 0112 5c6.4 0 10 7 10 7a17 17 0 01-2.9 3.8M6.6 6.6C3.8 8.4 2 12 2 12s3.6 7 10 7c1.9 0 3.5-.5 4.9-1.3M9.9 9.9a3 3 0 004.2 4.2",
};

export function Icon({ name, size = 18, className }: { name: keyof typeof PATHS | string; size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={name === "more" ? 3 : 2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
      <path d={PATHS[name] ?? ""} />
    </svg>
  );
}
